<template>
  <div class="businessApplicationList">
    <vm-table
        ref="vmTable"
        height="60vh"
        :filter.sync="filter"
        module="basic"
        url="sd/ba"
        @select="selectTest">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="商务编号">
            <el-input v-model.trim="filter.businessApplicationNO" clearable/>
          </vm-search>
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.customer" clearable/>
          </vm-search>
          <vm-search label="制单时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.orderBeginDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 190px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.orderEndDate"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
        <vm-search label="状态">
          <el-select v-model.trim="filter.status" clearable placeholder="请选择">
            <el-option
                v-for="item in constant.toSelect(constant.BusinessApplicationStatus)"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </vm-search>
        <vm-search label="申请人">
          <el-input v-model.trim="filter.creator" clearable/>
        </vm-search>
        <vm-search label="提交时间">
          <div class="block">
            <el-date-picker
                v-model="filter.submitBeginDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.submitEndDate"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="理由">
          <el-input v-model.trim="filter.reason" clearable/>
        </vm-search>
        <vm-search label="类型">
          <el-input v-model.trim="filter.businessBAType" clearable/>
        </vm-search>
        <vm-search label="备注">
          <el-input v-model.trim="filter.note" clearable/>
        </vm-search>
      </template>
      <!--  <el-table-column align="center" type="selection" width="40"/>-->
      <el-table-column
          prop="accessory"
          label=""
          :render-header="renderHeader"
          width="50"
          align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.accessory > 0">
            <i class="el-icon-paperclip"/>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="businessApplicationNO" label="商务编号" width="105">
        <template slot-scope="scope">
          <a @click="goto(scope.row)">{{scope.row.businessApplicationNO}}</a>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="customerName" label="客户名称"/>
      <el-table-column align="center" prop="employeeName" label="申请人" width="120"/>
      <el-table-column align="center" prop="createdDate" label="制单时间" width="140"/>
      <el-table-column align="center" prop="status" label="状态" width="120">
        <template slot-scope="scope">
          <span>{{constant.BusinessApplicationStatus[scope.row.status]}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="reason" label="理由"/>
      <el-table-column align="center" prop="submitTime" label="提交" width="140"/>
      <el-table-column v-if="editAuth" label="操作" align="center" width="200" class-name="vm-table_operate">
        <template slot-scope="scope">
          <span>
            <el-button type="danger" @click="reject(scope.row)">退回</el-button>
            <el-button type="danger" @click="pass(scope.row)">通过</el-button>
            <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
          </span>
        </template>
      </el-table-column>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";

  export default {
    name: "BusinessApplicationList",
    components: {VmTable, VmSearch},
    data() {
      return {
        // path:"/businessApplicationDetail/:businessApplicationId",
        // name:"businessApplicationDetail",
        constant,
        editAuth: this.$auth(647),
        idList: "",
        filter: {
          businessApplicationNO: "",
          customerName: "",
          creator: "",
          businessBAType: "",
          status: "",
          reason: "",
          note: "",
          orderBeginDate: "",
          orderEndDate: "",
          submitBeginDate: "",
          submitEndDate: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      businessApplicationDetail(row) {
        this.$router.push({name: "/BusinessApplicationDetail", query: {id: row.businessApplicationID}});
      },
      renderHeader(h, {column}) {
        return h(
            "span",
            [
              h("span", column.label),
              h("i", {
                class: "el-icon-paperclip",
                style: "color:#444444; font-size: 16px;",
              }),
            ],
        );
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .delete("basic", "sd/ba", row.businessApplicationID).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },

      //驳回
      reject(row) {
        this.$confirm("确定驳回吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", "sd/ba/updateBusinessApplicationStatus/" + row.businessApplicationID + "/" + 2201).then(() => {
            this.getList(-1);
            this.$message.success("驳回成功");
          });
        });
      },

      //通过
      pass(row) {
        this.$confirm("确定通过吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", "sd/ba/updateBusinessApplicationStatus/" + row.businessApplicationID + "/" + 2203).then(() => {
            this.getList(-1);
            this.$message.success("通过成功");
          });
        });
      },

      goto(row) {
        this.$router.push({
          path: "/businessApplication",
          query: {
            billType: 3,
            billId: row.billID,
            businessApplicationID: row.businessApplicationID,
            $tabName: "商务申请预览" + row.businessApplicationNO,
          },
        });
      },
    },
  };
</script>
<style lang="scss">
.businessApplicationList {
  .vm-search-label {
    width: 68px !important;
    text-align: left !important;
  }
}

/*@media only screen and (min-width: 1600px){*/
/*.customerList{*/
/*   table tr td {*/
/*     font-size: 14px;*/
/*   }*/
/*}*/
/*}*/

</style>
